import type { IconData } from '@stacksjs/iconify-core'

export const endPointDiamondFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M38.591 14.88a2.98 2.98 0 0 0-3.969 0c-.88.77-2.105 1.896-3.672 3.463a89 89 0 0 0-2.102 2.17c-1.655-.008-3.523-.013-5.631-.013H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h21.217c2.108 0 3.976-.005 5.63-.013a92 92 0 0 0 2.103 2.17a76 76 0 0 0 3.672 3.463a2.98 2.98 0 0 0 3.969 0c.88-.77 2.105-1.895 3.672-3.463a76 76 0 0 0 3.463-3.672a2.98 2.98 0 0 0 0-3.97a76 76 0 0 0-3.462-3.672a76 76 0 0 0-3.673-3.462Z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default endPointDiamondFlat
